/******/ (() => { // webpackBootstrap
/*!*********************************!*\
  !*** ./src/js/sections/tabs.js ***!
  \*********************************/
function tabsInit() {
  const tabsAction = document.querySelectorAll('.tab-selection-action');
  tabsAction.forEach(function (element) {
    element.addEventListener('click', e => {
      const id = e.target.dataset.tabId;
      const tabsContent = document.querySelectorAll('.tab-content');
      const newTab = document.querySelector('.tab-content[data-tab-id="' + id + '"]');
      if (newTab) {
        tabsContent.forEach(function (tab) {
          tab.classList.remove('active');
        });
        tabsAction.forEach(function (element) {
          element.classList.remove('active');
        });
        newTab.classList.add('active');
        e.target.classList.add('active');
      }
    });
  });
  if (tabsAction.length > 0) {
    tabsAction[0].click();
  }
}
tabsInit();
/******/ })()
;